//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pdf from 'vue-pdf'
import {system, getUserInfo, isApp} from '@/util/const'
import {setAuthorization} from '@/axios/userInfo'

export default {
    name: "pay",
    components: {
        pdf
    },
    data() {
        return {
            lang: '',
            rotate: 0,
            currentPage: 1,
            pageCount: 0,
            show: false,
            showToast: false,
            src: '',
            clickStop: false,
            selected: false,
        }
    },
    methods: {
        totalNum(num) {
            this.pageCount = num
        },
        prev() {
            this.currentPage = this.currentPage - 1
            if (this.currentPage < 1) this.currentPage = 1
        },
        next() {
            this.currentPage = this.currentPage + 1
            if (this.currentPage > this.pageCount) this.currentPage = this.pageCount
        },
        pay() {
            if (this.clickStop) return
            this.$Loading(true)
            this.clickStop = true
            let params = {
                "program_code": "20210204_MYLINK_3GB_LOCAL_UPGRADE_DATA_5G",
                'prize_code_list': ['1']
            }
            this.$http.postHK('/boss/mylink/api/prize/reserve', params).then(res => {
                this.showToast = false
                this.clickStop = false
                this.$router.push({
                    path: '/activity5G/result',
                    query: {
                        code: res.data.header.resultCode
                    }
                })
                this.$Loading(false)
            })
        },
        showToastBox(){
            if(!this.selected) return
            this.showToast = true
        }
    },
    mounted() {
        let that = this
        document.getElementById('pdf').addEventListener('click', () => {
            that.show = true
        })
    },
    created() {
        window.getUserInfo = (obj) => {
            if (obj) {
                setAuthorization(obj.authorization)
            }
            if (!isApp() || system() === 'unknown') {

            } else {
                getUserInfo({callbackName: 'getUserInfo', needLogin: false})
            }
        }
        this.lang = window.localStorage.lang
        if (this.lang === 'en') {
            this.src = 'https://mylink.oss-accelerate.aliyuncs.com/5gact/enPdf.pdf'
        } else {
            this.src = 'https://mylink.oss-accelerate.aliyuncs.com/5gact/tcPdf.pdf'
        }
    }
}



// WEBPACK FOOTER //
// ./src/page/activity5G/pay.vue